import React from 'react';
import {
  Boxes,
  ClipboardList,
  Factory,
  Landmark,
  ShoppingCart,
  Warehouse,
} from 'lucide-react';

const capabilities = [
  {
    title: 'Manufacturing',
    description: 'Plan production, manage capacity, and coordinate shop-floor operations. Keep work orders, materials, and schedules aligned across sites.',
    icon: Factory,
    color: '#10BFA5',
  },
  {
    title: 'Supply Chain',
    description: 'Connect demand, sourcing, inventory, and fulfillment across your network. Improve supply visibility and respond to changing requirements.',
    icon: Boxes,
    color: '#6815EA',
  },
  {
    title: 'Financial Management',
    description: 'Bring costing, accounting, and financial visibility together. Support reporting and financial control across business units.',
    icon: Landmark,
    color: '#FFB300',
  },
  {
    title: 'Procurement',
    description: 'Coordinate purchasing, supplier collaboration, and approvals. Keep procurement workflows consistent across the business.',
    icon: ShoppingCart,
    color: '#9C27B0',
  },
  {
    title: 'Warehouse & Inventory',
    description: 'Track materials, stock levels, and warehouse movement. Support accurate inventory and timely order fulfillment.',
    icon: Warehouse,
    color: '#4053BC',
  },
  {
    title: 'Project Management',
    description: 'Manage project costs, resources, milestones, and delivery. Keep project progress connected to operations and finance.',
    icon: ClipboardList,
    color: '#63A934',
  },
];

const CapabilityCard = ({ icon: Icon, title, description, color }) => (
  <article
    className="flex h-full min-h-[250px] flex-col items-center rounded-xl px-5 py-6 text-center transition duration-300 hover:-translate-y-1 hover:shadow-xl sm:min-h-[270px] sm:px-6 sm:py-7"
    style={{
      backgroundColor: '#FFFFFF',
      boxShadow: '0 8px 28px rgba(35, 50, 90, 0.035)',
    }}
  >
    <div className="mb-4 grid h-16 w-16 shrink-0 place-items-center rounded-full" style={{ backgroundColor: color }}>
      <Icon aria-hidden="true" className="h-7 w-7" style={{ color: '#FFFFFF' }} strokeWidth={2.2} />
    </div>
    <h3 className="text-lg font-medium leading-snug sm:text-xl" style={{ color: '#101A3A' }}>
      {title}
    </h3>
    <p className="mt-2 max-w-sm text-sm leading-6 sm:text-base" style={{ color: '#57708E' }}>
      {description}
    </p>
  </article>
);

const LnCapabilities = () => (
  <section aria-labelledby="ln-capabilities-title" className="px-5 py-10 sm:px-6 lg:px-8 lg:py-12" style={{ backgroundColor: '#F4F6FB' }}>
    <div className="mx-auto w-full max-w-7xl">
      <div className="mb-7 text-left sm:mb-8">
        <h2 id="ln-capabilities-title" className="text-2xl font-semibold tracking-tight sm:text-3xl" style={{ color: '#101A3A' }}>
          Infor LN Capabilities
        </h2>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
        {capabilities.map((capability) => (
          <CapabilityCard key={capability.title} {...capability} />
        ))}
      </div>
    </div>
  </section>
);

export default LnCapabilities;
